document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-media-carousel');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('.product-media-carousel__track');
    const slides = Array.from(
      carousel.querySelectorAll('.product-media-carousel__slide')
    );
    const prevButton = carousel.querySelector(
      '.product-media-carousel__arrow--prev'
    );
    const nextButton = carousel.querySelector(
      '.product-media-carousel__arrow--next'
    );

    if (!track || slides.length === 0) return;

    let currentIndex = slides.findIndex((slide) =>
      slide.classList.contains('is-active')
    );
    if (currentIndex === -1) currentIndex = 0;

    const update = () => {
      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === currentIndex);
      });
      track.style.transform = `translateX(-${currentIndex * 100}%)`;

      if (prevButton) prevButton.disabled = currentIndex === 0;
      if (nextButton) nextButton.disabled = currentIndex === slides.length - 1;
    };

    const goTo = (index) => {
      if (index < 0 || index >= slides.length) return;
      currentIndex = index;
      update();
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        goTo(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goTo(currentIndex + 1);
      });
    }

    // Initial state
    update();
  });
});
